import React, { useCallback, useMemo, useState } from 'react';
import { IBreadcrumb } from '@/components/common/breadcrumbs';

export interface IBreadcrumbContextType {
  breadcrumbs: IBreadcrumb[];
  setBreadcrumbs: (items: IBreadcrumb[]) => void;
}

export const BreadcrumbContext =
  React.createContext<IBreadcrumbContextType | null>(null);

interface IBreadcrumbProvider {
  children?: React.ReactNode;
}

const BreadcrumbProvider: React.FC<IBreadcrumbProvider> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbsItems] = useState<IBreadcrumb[]>([]);

  const setBreadcrumbs = useCallback((items: IBreadcrumb[]) => {
    setBreadcrumbsItems(items);
  }, []);

  const value = useMemo(
    () => ({ breadcrumbs, setBreadcrumbs }),
    [breadcrumbs, setBreadcrumbs]
  );

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export default BreadcrumbProvider;
